import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GroupItemBaseModel } from '@libs/form/models';
import { ItemBaseComponent } from './item-base.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export abstract class GroupBaseComponent extends ItemBaseComponent {
  @Input() public control!: UntypedFormGroup;

  public abstract override data: GroupItemBaseModel;

  public override get classList(): string[] {
    return [
      'form-group',
      ...super.classList,
    ];
  }
}
